import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const usePopupStore = defineStore('popup', () => {
  // State -----------------------------------------
  const popup = ref('')

  // Getters ---------------------------------------
  const hasPopup = computed(() => (popup.value !== '' ? true : false))

  // Actions ---------------------------------------
  function $reset() {
    popup.value = ''
  }

  function openPopup(name) {
    popup.value = name
  }

  function closePopup() {
    popup.value = ''
  }

  // Main Setup ------------------------------------

  // -----------------------------------------------
  return { popup, hasPopup, $reset, openPopup, closePopup }
})
